/* LQK prayer-time location table.
   Row: code|country|city|lat|lng|IANA tz|AlAdhan method|school(0 Shafi,1 Hanafi)|authority|fajr angle|isha angle|isha minutes after maghrib (0 = use angle)
   The method column is what makes times match each country's official authority. */
window.LQK_PRAYER_LOCATIONS = [
'SG|Singapore|Singapore|1.3521|103.8198|Asia/Singapore|11|0|MUIS|20|18|0',
'MY|Malaysia|Kuala Lumpur|3.139|101.6869|Asia/Kuala_Lumpur|17|0|JAKIM|20|18|0',
'ID|Indonesia|Jakarta|-6.2088|106.8456|Asia/Jakarta|20|0|Kemenag|20|18|0',
'BN|Brunei|Bandar Seri Begawan|4.9031|114.9398|Asia/Brunei|17|0|JAKIM|20|18|0',
'TH|Thailand|Bangkok|13.7563|100.5018|Asia/Bangkok|3|0|Muslim World League|18|17|0',
'PH|Philippines|Manila|14.5995|120.9842|Asia/Manila|3|0|Muslim World League|18|17|0',
'IN|India|New Delhi|28.6139|77.209|Asia/Kolkata|1|1|Karachi|18|18|0',
'PK|Pakistan|Karachi|24.8607|67.0011|Asia/Karachi|1|1|Karachi|18|18|0',
'BD|Bangladesh|Dhaka|23.8103|90.4125|Asia/Dhaka|1|1|Karachi|18|18|0',
'LK|Sri Lanka|Colombo|6.9271|79.8612|Asia/Colombo|1|0|Karachi|18|18|0',
'MV|Maldives|Male|4.1755|73.5093|Indian/Maldives|3|0|Muslim World League|18|17|0',
'SA|Saudi Arabia|Makkah|21.3891|39.8579|Asia/Riyadh|4|0|Umm al-Qura|18.5|0|90',
'AE|United Arab Emirates|Dubai|25.2048|55.2708|Asia/Dubai|16|0|Dubai|18.2|18.2|0',
'QA|Qatar|Doha|25.2854|51.531|Asia/Qatar|10|0|Qatar|18|0|90',
'KW|Kuwait|Kuwait City|29.3759|47.9774|Asia/Kuwait|9|0|Kuwait|18|17.5|0',
'BH|Bahrain|Manama|26.2285|50.586|Asia/Bahrain|8|0|Gulf|19.5|0|90',
'OM|Oman|Muscat|23.588|58.3829|Asia/Muscat|8|0|Gulf|19.5|0|90',
'JO|Jordan|Amman|31.9454|35.9284|Asia/Amman|23|0|Jordan|18|18|0',
'PS|Palestine|Jerusalem|31.7683|35.2137|Asia/Hebron|3|0|Muslim World League|18|17|0',
'LB|Lebanon|Beirut|33.8938|35.5018|Asia/Beirut|3|0|Muslim World League|18|17|0',
'IQ|Iraq|Baghdad|33.3152|44.3661|Asia/Baghdad|3|0|Muslim World League|18|17|0',
'IR|Iran|Tehran|35.6892|51.389|Asia/Tehran|7|0|Tehran|17.7|14|0',
'TR|Turkey|Istanbul|41.0082|28.9784|Europe/Istanbul|13|0|Diyanet|18|17|0',
'EG|Egypt|Cairo|30.0444|31.2357|Africa/Cairo|5|0|Egyptian Authority|19.5|17.5|0',
'MA|Morocco|Casablanca|33.5731|-7.5898|Africa/Casablanca|21|0|Morocco|19|17|0',
'DZ|Algeria|Algiers|36.7538|3.0588|Africa/Algiers|19|0|Algeria|18|17|0',
'TN|Tunisia|Tunis|36.8065|10.1815|Africa/Tunis|18|0|Tunisia|18|18|0',
'NG|Nigeria|Lagos|6.5244|3.3792|Africa/Lagos|3|0|Muslim World League|18|17|0',
'KE|Kenya|Nairobi|-1.2921|36.8219|Africa/Nairobi|3|0|Muslim World League|18|17|0',
'ZA|South Africa|Johannesburg|-26.2041|28.0473|Africa/Johannesburg|3|0|Muslim World League|18|17|0',
'GB|United Kingdom|London|51.5074|-0.1278|Europe/London|3|0|Muslim World League|18|17|0',
'IE|Ireland|Dublin|53.3498|-6.2603|Europe/Dublin|3|0|Muslim World League|18|17|0',
'FR|France|Paris|48.8566|2.3522|Europe/Paris|12|0|UOIF France|12|12|0',
'DE|Germany|Berlin|52.52|13.405|Europe/Berlin|3|0|Muslim World League|18|17|0',
'NL|Netherlands|Amsterdam|52.3676|4.9041|Europe/Amsterdam|3|0|Muslim World League|18|17|0',
'ES|Spain|Madrid|40.4168|-3.7038|Europe/Madrid|3|0|Muslim World League|18|17|0',
'IT|Italy|Rome|41.9028|12.4964|Europe/Rome|3|0|Muslim World League|18|17|0',
'SE|Sweden|Stockholm|59.3293|18.0686|Europe/Stockholm|3|0|Muslim World League|18|17|0',
'RU|Russia|Moscow|55.7558|37.6173|Europe/Moscow|14|0|Russia|16|15|0',
'US|United States|New York|40.7128|-74.006|America/New_York|2|0|ISNA|15|15|0',
'CA|Canada|Toronto|43.6532|-79.3832|America/Toronto|2|0|ISNA|15|15|0',
'AU|Australia|Sydney|-33.8688|151.2093|Australia/Sydney|3|0|Muslim World League|18|17|0',
'NZ|New Zealand|Auckland|-36.8485|174.7633|Pacific/Auckland|3|0|Muslim World League|18|17|0',
'CN|China|Beijing|39.9042|116.4074|Asia/Shanghai|3|0|Muslim World League|18|17|0',
'JP|Japan|Tokyo|35.6762|139.6503|Asia/Tokyo|3|0|Muslim World League|18|17|0'
];

/* Time zones that need finer coordinates than the country's default city.
   Row: IANA tz|country code|lat|lng */
window.LQK_PRAYER_TZ_OVERRIDES = [
'America/Chicago|US|41.8781|-87.6298',
'America/Denver|US|39.7392|-104.9903',
'America/Phoenix|US|33.4484|-112.074',
'America/Los_Angeles|US|34.0522|-118.2437',
'America/Anchorage|US|61.2181|-149.9003',
'Pacific/Honolulu|US|21.3069|-157.8583',
'America/Detroit|US|42.3314|-83.0458',
'America/Vancouver|CA|49.2827|-123.1207',
'America/Edmonton|CA|53.5461|-113.4938',
'America/Winnipeg|CA|49.8951|-97.1384',
'America/Halifax|CA|44.6488|-63.5752',
'Australia/Melbourne|AU|-37.8136|144.9631',
'Australia/Brisbane|AU|-27.4698|153.0251',
'Australia/Perth|AU|-31.9505|115.8605',
'Australia/Adelaide|AU|-34.9285|138.6007',
'Australia/Darwin|AU|-12.4634|130.8456',
'Asia/Makassar|ID|-5.1477|119.4327',
'Asia/Jayapura|ID|-2.5337|140.7181',
'Asia/Pontianak|ID|-0.0263|109.3425',
'Asia/Kuching|MY|1.5535|110.3593',
'Asia/Calcutta|IN|28.6139|77.209',
'Asia/Dacca|BD|23.8103|90.4125',
'Europe/Kaliningrad|RU|54.7104|20.4522',
'Asia/Yekaterinburg|RU|56.8389|60.6057'
];
